import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../Store";
import ETAcomponent from "./ETAcomponent";
import CallButtonModel from "../../CallButtonModel";

const InfoContainer = () => {
  const { casesStore } = useStore();
  const { t } = useTranslation();

  const brand = casesStore.brand;
  const sLatestEvent = casesStore.latestEvent;

  if (sLatestEvent == null) {
    return (
      <div id="info-container">
        <div id="error-warning">{t("error2")}</div>
        <div id="contact-page-button"></div>
        <div id="info-container-info">
          <CallButtonModel noEvent />
        </div>
      </div>
    );
  }
  return (
    <div id="info-container">
      <div className="info-container-header">
        <p>Roadside Assistance</p>
      </div>
      <div id="info-container-info">
        <div className="info-container-info-block">
          <div className="info-container-contact-info">
            <p>{t("EstimatedArrival")}</p>
            <div className={`info-container-contact-info-ETA product-font-${brand}`}>
              <p>{t("ETA")}</p>
              <ETAcomponent />
            </div>
            <hr/>
            <p>{t("CurrentStatus")}:</p>
            <div className="current-state-container">
              <p>{t(`statuscontainerevent${sLatestEvent.eventType}`)}</p>
            </div>
            <div className="clear-both"></div>
          </div>
        </div>  
      </div>
      <CallButtonModel />
    </div>
  );
};

export default observer(InfoContainer);